<template>
  <div class="container-fluid">
    <loading :active.sync="isLoading" loader="dots"></loading>

    <div class="page-tabs">
      <template v-for="(item, index) in rows">
        <a
          :key="item.index"
          :class="{ active: currentTab === index }"
          @click.prevent="currentTab = index"
          href="#"
        >
          {{ item.title }}
        </a>
      </template>
    </div>

    <div class="page-tabs-content">
      <ValidationObserver v-slot="{ handleSubmit }">
        <div v-for="(item, index) in rows" :key="item.index">
          <table class="table" v-if="currentTab === index">
            <tbody>
              <tr v-for="data in item.content" :key="data.index">
                <th id="item" style="width: 300px">
                  {{ data.Item }}
                </th>
                <!-- 字串格式 -->
                <td>
                  <template v-if="data.DataType === 0">
                    <input
                      type="text"
                      class="form-control"
                      v-model.trim="data.Value"
                    />
                  </template>

                  <template v-if="data.DataType === 1">
                    <el-radio v-model="data.Value" label="true">
                      {{ i18n("Basic.On") }}
                    </el-radio>
                    <el-radio v-model="data.Value" label="false">
                      {{ i18n("Basic.Off") }}
                    </el-radio>
                  </template>

                  <template v-if="data.DataType === 3">
                    <ValidationProvider
                      rules="required"
                      :name="data.Item"
                      v-slot="{ errors }"
                    >
                      <input
                        type="number"
                        min="1"
                        class="form-control"
                        v-model.number="data.Value"
                      />
                      <span v-if="errors[0]" class="text-danger ml-1">
                        {{ errors[0] }}
                      </span>
                    </ValidationProvider>
                  </template>
                </td>
              </tr>
              <tr>
                <td colspan="2" class="text-center">
                  <button
                    type="button"
                    class="btn btn-primary"
                    @click="handleSubmit(editConfig)"
                  >
                    {{ i18n("Buttons.Save") }}
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </ValidationObserver>
    </div>
  </div>
</template>

<script>
export default {
  name: "ParameterSetting",

  data() {
    return {
      currentTab: 0,

      // data
      rows: [],
    };
  },

  computed: {
    isLoading() {
      return this.$store.state.isLoading;
    },
  },

  methods: {
    // 多國語系
    i18n(keyStr) {
      return this.$t(keyStr);
    },

    // 點擊上傳圖片按鈕
    clickUpload(category) {
      this.imgCategory = category;
    },

    getConfig() {
      const vm = this;
      let data = {
        isShow: true,
      };

      vm.$api.InterviewSch.getConfig(data)
        .then((response) => {
          if (response.data.ErrorMessage) {
            this.$notify({
              message: response.data.ErrorMessage,
              type: "error",
            });
          } else {
            let arr = [];
            this.rows = [];
            arr = Object.keys(response.data.Data);
            for (const title of arr) {
              this.rows.push({
                title,
                content: response.data.Data[title],
              });
            }
          }
          vm.$loadingStore.closeLoading();
        })
        .catch((error) => {
          vm.$loadingStore.closeLoading();
          this.$notify({
            title: "錯誤",
            message: error.response.data.ErrorMessage,
            type: "error",
          });
        });
    },
    editConfig() {
      const vm = this;
      let data = [];
      vm.rows.forEach((item) => {
        data = [
          ...data,
          ...item.content.map((innerItem) => {
            return {
              Guid: innerItem.Guid,
              Value: innerItem.Value,
            };
          }),
        ];
      });

      vm.$api.InterviewSch.editConfig(data)
        .then((response) => {
          if (response.data.ErrorMessage) {
            this.$notify({
              message: response.data.ErrorMessage,
              type: "error",
            });
          } else {
            vm.getConfig();
            vm.$notify({
              message: response.data.Data,
              type: "success",
            });
          }
          vm.$loadingStore.closeLoading();
        })
        .catch((error) => {
          vm.$loadingStore.closeLoading();
          this.$notify({
            title: "錯誤",
            message: error.response.data.ErrorMessage,
            type: "error",
          });
        });
    },
  },

  created() {
    this.getConfig();
  },
};
</script>
